// export const categoriesOrder = [
//     'Laundry',
//     'Refrigeration',
//     'Cooking',
//     'Dishwasher',
//     'LG Studio',
// ];


export const CATEGORY_NAMES_ENGLISH = {
    "Dishwasher": "Dishwasher",
    "Cooking": "Cooking",
    "Laundry": "Laundry",
    "Refrigeration": "Refrigeration",
    "LG Studio": "LG Studio"
};
// export const subcategoryNamesInEnglish = {
//     "Cooking": [
//         // "Electric Range", "Gas Range", "Built-in Wall Oven", "Built-in Cooktop", "Over-the-Range Microwave", "Countertop Microwave"
//         "Electric Slide-in Ranges", "Electric Free-standing Ranges",
//         "Induction Ranges", "Gas Ranges",
//         "Wall Ovens", "Cooktops", "Over-the-Range Microwaves", "Countertop Microwaves"
//     ],
//     "Laundry": [
//         "Front Load", "WashTower", "Top Load", "Specialty Laundry",
//         // NEW
//         "Accessories"
//     ],
//     "LG Studio": [
//         // "Laundry", "Refrigeration", "Cooking", "Dishwasher",  
//         "Laundry", "Refrigeration", "Built-in Cooking", "Free-standing Cooking", "Ventilation", "Dishwashers",
//     ],
//     "Dishwasher": [
//         "Built-in"
//     ],
//     "Refrigeration": [
//         // "French Door, Side-by-Side", "Top and Bottom Mount", "Column", "Kimchi"	
//         "36\" French Door Standard Depth", "36\" French Door Counter Depth",
//         "33\" French Door Standard Depth", "33\" French Door Counter Depth",
//         "30\" French Door", "Top and Bottom Mount", "Side-by-Side", "Column", "Kimchi"
//     ],
// }
// export const categoryNamesInFrench = {
//     "Cooking": "Cuisson",
//     "Dishwasher": "Lave-vaisselle",
//     "Laundry": "Lessive",
//     "Refrigeration": "Réfrigérateur",
//     "LG Studio": "LG Studio"
// };
export const CATEGORY_DESCRIPTION = {
  EN: {
    "Cooking": `The star of the show, LG kitchen ranges & ovens offer precision and performance unlike any others in the market. With a variety of innovative features, our ranges can help you create dishes that will leave your guests demanding an encore.`,
    "Dishwasher": `LG’s sleek and powerful dishwashers will make your dishes shine. With intuitive controls, adjustable racks, and a large load capacity LG dishwashers make kitchen clean up a breeze.`,
    "LG Studio": `Say hello to the LG Studio Kitchen. With innovative freestanding and built-in appliances that perform flawlessly and look awesome, you may never want to leave your home again.`,
    "Laundry": `Whether you’re looking for side-by-side laundry machines, stackable washers and dryers, or all-in-one laundry appliances that offer powerful washing and drying in a single, space-saving machine, LG offers a wide range of reliable, innovative solutions.`,
    "Refrigeration": `Make the most out of life. Whether you’re replacing a kitchen appliance, adding a laundry room or furnishing your whole house, look to LG for stylish and innovative appliances that fit your lifestyle and match your home’s décor.`,
  },
  FR: {
    "Cooking": `Que vous recherchiez des appareils de lavage côte à côte, des laveuses et des sécheuses empilables, ou des appareils tout-en-un qui offrent un lavage et un séchage puissants dans une seule unité compacte, LG offre une vaste gamme de solutions fiables et innovantes.`,
    "Dishwasher": `Élégants et puissants, les lave-vaisselle de LG feront briller votre vaisselle. Avec des commandes intuitives, des paniers ajustables et une grande capacité, les lave-vaisselle de LG peuvent désencombrer votre cuisine en un tour de main.`,
    "LG Studio": `Dites bonjour à la cuisine LG Studio. Grâce à ces appareils innovateurs non encastrés et intégrés qui ont fière allure et fonctionnent parfaitement, vous ne voudrez plus jamais sortir de votre maison.`,
    "Laundry": `Que vous recherchiez des appareils de lavage côte à côte, des laveuses et des sécheuses empilables, ou des appareils tout-en-un qui offrent un lavage et un séchage puissants dans une seule unité compacte, LG offre une vaste gamme de solutions fiables et innovantes.`,
    "Refrigeration": `Profitez pleinement de la vie. Que ce soit pour remplacer un électroménager de cuisine, ajouter une salle de lavage ou meubler votre maison, vous pouvez compter sur LG pour trouver des électroménagers élégants et novateurs qui correspondent à votre style de vie et s’harmonisent avec le décor de votre maison.`,
  }
};



export const subCategoryOrderEN = {
  "LG Studio": [
    "Laundry",
    "Refrigeration",
    "Built-in Cooking",
    "Free-standing Cooking",
    "Ventilation",
    "Dishwashers",
  ],
  "Laundry": [
    "Front Load",
    "WashTower",
    "Top Load",
    "Specialty Laundry",
    // NEW
    "Accessories",

  ],
  "Refrigeration": [
    "36\" French Door Standard Depth",
    "36\" French Door Counter Depth",
    "33\" French Door Standard Depth",
    "33\" French Door Counter Depth",
    "30\" French Door",
    "Top and Bottom Mount",
    "Side-by-Side",
    "Column",
    "Kimchi",
  ],
  "Cooking": [
    "Electric Slide-in Ranges",
    "Electric Free-standing Ranges",
    "Induction Ranges",
    "Gas Ranges",
    "Wall Ovens",
    "Cooktops",
    "Over-the-Range Microwaves",
    "Countertop Microwaves",
  ],

  "Dishwasher": [
    "Built-in"
  ],
}
export const subCategoryOrderFR = {
  "LG Studio": [
    "Lessive",
    "Réfrigérateur",
    "Cuisson intégré",
    "Cuisson autonome",
    "Ventilation",
    "Lave-vaisselles",
  ],
  "Laundry": [
    "Chargement frontal",
    "WashTower",
    "Chargement vertical",
    "Appareils spécialisés",
    // NEW
    "Accessoires"
  ],
  "Refrigeration": [
    "Porte à deux battants profondeur standard de 36 po",
    "Porte à deux battants profondeur de comptoir de 36 po",
    "Porte à deux battants profondeur standard de 33 po",
    "Porte à deux battants profondeur de comptoir de 33 po",
    "Porte à deux battants de 30 po",
    "Congélateur en haut et bas",
    "Côte-à-côte",
    "Colonne",
    "Kimchi"
  ],
  "Cooking": [
    "Cuisinière encastrable électrique",
    "Cuisinières encastrable électriques",
    "Cuisinières à inductions",
    "Cuisinière au gaz",
    "Four mural",
    "Surface de cuisson",
    "Four à micro-ondes à hotte intégrée",
    "Four à micro-ondes de comptoir",
  ],
  "Dishwasher": [
    "Intégré"
  ],
}
